import { render } from "./ThankYouPage.vue?vue&type=template&id=043ba46a&scoped=true"
import script from "./ThankYouPage.vue?vue&type=script&lang=js"
export * from "./ThankYouPage.vue?vue&type=script&lang=js"

import "./ThankYouPage.vue?vue&type=style&index=0&id=043ba46a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-043ba46a"]])

export default __exports__